import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

type Props = {
  color: string,
  width: string,
  tooltipText: string,
};

const Span = styled.span<{ width: string, color: string }>`
  width: ${(props) => props.width};
  background-color: ${(props) => props.color};
  display: inline-block;
  height: 100%;
`;
const HeatMapTooltipItem = function HeatMapTooltipItem(props: Props) {
  const { color, width, tooltipText } = props;

  return (
    <Tooltip
      placement="top"
      getPopupContainer={(e: HTMLElement) => e}
      className="triggers-bullet-tooltip tooltip-item"
      color="#fff"
      title={tooltipText}
      arrow={false}
    >
      <Span width={width} color={color} />
    </Tooltip>
  );
};

export default HeatMapTooltipItem;
